import { Button, Card, CardContent, CardDescription, CardGroup, CardHeader, CardMeta, Container, Grid, GridColumn, GridRow, Icon, Image } from 'semantic-ui-react';
import styles from './ClubPage.module.css';
import Member from './Member';
import Ambassador from './Ambassador';

const ClubPage = () => {
    return (
        <>
            <div className={styles.hero}>
                <img src="/assets/clubhero.jpg" style={{ minWidth: 768 }} />
                <div className={styles.herotext}>
                    <h1>Клуб охотника</h1>
                    <p></p>
                </div>
            </div>
            <Container className={styles.container}>
                <div>
                    <p>Клуб предлагает разные уровни членства, «Member»(член) и «Ambassador»(посланник). Члены получают доступ к основным мероприятиям. "Ambassador" — к эксклюзивным привилегиям, таким как специальные туры, встречи с экспертами.</p>
                    <p>Клуб организует регулярные мероприятия — от образовательных семинаров до охот на трюфели. «Ambassador»ы могут участвовать в закрытых мероприятиях, эксклюзивных турах.</p>
                    <p>Клуб может предлагать обучение по поиску трюфелей, кулинарные мастер-классы и дегустации.</p>
                    <p>Создание онлайн-платформы для общения членов клуба, обмена опытом и советами.</p>
                    <p>А так же члены клубов могут арендовать трюфельных собак для охоты. Эта услуга для мемберов платная, для амбасадоров в году один раз бесплатная</p>
                </div>





            </Container>

            <Grid columns='equal'>
                <GridRow only='computer tablet'>
                    <GridColumn width={3}></GridColumn>
                    <GridColumn width={5}>
                        <Member />
                    </GridColumn>

                    <GridColumn width={5}>
                        <Ambassador />
                    </GridColumn>
                    <GridColumn width={3}></GridColumn>

                </GridRow>



                <GridRow only='mobile'>
                    <GridColumn width={16}>
                        <Member />
                    </GridColumn>
                </GridRow>
                <GridRow only='mobile'>
                    <GridColumn width={16}>
                        <Ambassador />
                    </GridColumn>
                </GridRow>
            </Grid>
        </>);
}

export default ClubPage